/* Progressive enhancement only. Article content and navigation work without JavaScript. */
(() => {
  function prepareArticle(scope = document) {
    scope.querySelectorAll('[data-sc-article]').forEach(article => {
      const index = article.querySelector('[data-sc-article-index]');
      if (!index || index.dataset.ready) return;
      const headings = [...article.querySelectorAll('.blog-post-content h2, .blog-post-content h3')]
        .filter(heading => heading.textContent.trim()).slice(0, 12);
      if (headings.length < 2) return;
      const list = index.querySelector('ol');
      headings.forEach((heading, position) => {
        if (!heading.id) {
          let id = `story-${article.closest('.shopify-section')?.id || 'article'}-${position + 1}`;
          while (document.getElementById(id)) id += '-heading';
          heading.id = id;
        }
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${encodeURIComponent(heading.id)}`;
        link.textContent = heading.textContent.trim();
        item.append(link);
        list.append(item);
      });
      article.querySelector('.blog-post-content')?.before(index);
      index.hidden = false;
      index.dataset.ready = 'true';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => prepareArticle());
  else prepareArticle();
  document.addEventListener('shopify:section:load', event => prepareArticle(event.target));
})();
